<template>
  <auth>
    <div class="auth">
      <form @submit.prevent="validateForm()">
        <br>
        <h4>Validate your Bid Bond</h4>
        <hr>
        <div class="form-group">
          <label>Enter Reference Number</label>
          <input
            v-model="reference"
            v-validate="'required|min:7|alpha_num'"
            placeholder="MD...."
            name="reference"
            type="text"
            class="form-control"
          >
          <small
            v-if="errors.has('reference')"
            class="help-block"
          >
            {{ errors.first('reference') }}
          </small>
        </div>
        <div class="form-group">
          <button
            v-if="loading"
            class="btn"
            type="button"
          >
            <i class="fa fa-spin fa-spinner" /> Loading ...
          </button>
          <button
            v-else
            class="btn btn-secondary"
            type="submit"
          >
            <i class="fa fa-search" /> Search
          </button>
        </div>
      </form>
    </div>
  </auth>
</template>

<script>
import Auth from "@/components/Auth.vue";

export default {
  components: {
    Auth
  },
  data() {
    return {
      reference: '',
      loading: false,
    }
  },
  methods: {
    validateForm() {
      return this.$validator.validateAll().then(result => {
        if (result) {
          this.search();
        }
      });
    },
    search() {
      this.loading = true;
      this.$axios.get(`/api/bidbonds/${this.reference}/byReference`, {
        method: 'GET',
        responseType: 'blob'
      }).then(response => {
        const file = new Blob(
            [response.data],
            {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }).catch(() => {
        this.$toastr.e("Failed to find Bidbond!");
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>
